import { useEffect, useState } from 'react'
import { useConfigStore } from '@renderer/stores/configState'
import { getAutoTextColor } from '@renderer/utils/colorUtils'

export const useBackgroundTextColor = (): string => {
  const { config } = useConfigStore()
  const [textColor, setTextColor] = useState<string>('#000000')
  
  useEffect(() => {
    const detectColor = async (): Promise<void> => {
      const detected = await getAutoTextColor(
        config?.theme.backgroundColor,
        config?.theme.backgroundImageUrl
      )
      setTextColor(detected)
    }
    
    detectColor()
  }, [config?.theme.backgroundColor, config?.theme.backgroundImageUrl])
  
  return textColor
}

